import { withInstall as o } from "../../utils/with-install.js";
import t from "./dialog.vue.js";
/* empty css            */
const a = o(t);
export {
  a as ApDialog,
  a as default
};
